import type * as Types from 'app/types/graphql';

import { ShopPlatformPlanCancelSelectFragmentDoc } from '../fragments/shopPlatformPlan.generated';
import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import { appFetcher } from '~/api/utils/gatewayClient';
export type ShopPlatformPlanCancelMutationVariables = Types.Exact<{
  shopPlatformID: Types.Scalars['ID']['input'];
}>;

export type ShopPlatformPlanCancelMutationResponse = {
  shopPlatformPlanCancel?: Types.Maybe<
    Pick<Types.ShopPlatformPlan, 'id' | 'planID' | 'startDate' | 'endDate'>
  >;
};

export const ShopPlatformPlanCancelDocument = `
    mutation ShopPlatformPlanCancel($shopPlatformID: ID!) {
  shopPlatformPlanCancel(shopPlatformID: $shopPlatformID) {
    ...ShopPlatformPlanCancelSelect
  }
}
    ${ShopPlatformPlanCancelSelectFragmentDoc}`;

export const useShopPlatformPlanCancelMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    ShopPlatformPlanCancelMutationResponse,
    TError,
    ShopPlatformPlanCancelMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    ShopPlatformPlanCancelMutationResponse,
    TError,
    ShopPlatformPlanCancelMutationVariables,
    TContext
  >(
    ['ShopPlatformPlanCancel'],
    (variables?: ShopPlatformPlanCancelMutationVariables) =>
      appFetcher<ShopPlatformPlanCancelMutationResponse, ShopPlatformPlanCancelMutationVariables>(
        ShopPlatformPlanCancelDocument,
        variables,
      )(),
    options,
  );
};

useShopPlatformPlanCancelMutation.getKey = () => ['ShopPlatformPlanCancel'];
